<template>
  <div class="ui container">
    <div class="ui grid px-gen m-0 py-1">
      <div class="wide column px-gen">
        <div class="pt-2">
          <h3
            class="ui dividing header fdinpro default-header-green is-uppercase"
          >
            Aprobacion de Bundle
          </h3>
        </div>
      </div>
    </div>
    <div class="table-codes- px-gen m-0 pb-05">
      <table class="ui striped selectable table px-gen" ref="table">
        <thead>
          <tr>
            <th class="is-uppercase">{{ $t("store") }}</th>
            <th class="is-uppercase">{{ $t("bundle") }}</th>
            <th class="is-uppercase">{{ $t("options") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(request, index) in requests" :key="index">
            <td>
              <div class="fluid ui sb-tienda">
                <div class="pre-sb-tienda">
                  {{ request.nvb_store.setup.country }}
                </div>
                <div class="name-sb-tienda">
                  <!-- <pre>{{ request }}</pre> -->
                  {{ request.nvb_store.setup.name }} [{{
                    request.usr_user.username
                  }}]
                </div>
              </div>
            </td>
            <td>
              <pre>{{ request.nvb_bundle.setup.name }}</pre>
            </td>
            <td><a href="#" @click="check(request)">REVISAR</a></td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="ui grid px-gen m-0" v-if="selected_bundle">
      <div class="wide column px-gen">
        <div class="pt-2">
          <h3
            class="ui dividing header fdinpro default-header-green is-uppercase"
          >
            Solicita Bundle
          </h3>
          <h4 class="ui header fdinpro is-uppercase my-0">
            BUNDLE: {{ selected_bundle.nvb_bundle.setup.name }}
          </h4>
          <h4 class="ui header fdinpro is-uppercase my-0">
            TIENDA: {{ selected_bundle.nvb_store.setup.name }} [{{
              selected_bundle.usr_user.name
            }}]
          </h4>
          <h5 class="ui header fdinpro is-uppercase my-0">
            FECHA: {{ selected_bundle.nvb_bundle.setup.start_date | dt }} AL
            {{ selected_bundle.nvb_bundle.setup.end_date | dt }}
          </h5>
        </div>
      </div>
    </div>
    <div
      class="ui grid px-gen m-0 py-1 testigos"
      ref="scrollToMe"
      v-if="selected_bundle"
    >
      <div class="ten wide column px-gen pl-0">
        <div class="ui form">
          <div class="field">
            <label for="">{{ $t("comment") }}</label>
            <textarea v-model="d.comment" cols="30" rows="2"></textarea>
          </div>
        </div>
      </div>
      <div class="six wide column px-gen pl-0">
        <div class="ui icon labeled green button" @click="approve">
          <i class="check icon"></i> {{ $t("approve") }}
        </div>
        <div class="ui icon labeled red button" @click="deny">
          <i class="remove icon"></i>{{ $t("deny") }}
        </div>
      </div>
      <div class="eight wide column px-gen pl-0">
        <p class="">Testigo web</p>
        <img
          class="ui fluid image"
          :src="api_host + '/' + selected_bundle.setup.web_witness.relative"
        />
        <div class="ui grid centered m-0">
          <div class="three wide column">Aprobar</div>
          <div class="three wide column has-text-right">
            <div
              class="ui fitted toggle checkbox"
              ref="web_witness_checkbox"
              :data-bundle="selected_bundle.nvb_bundle.bundle_id"
            >
              <input type="checkbox" v-model="d.web_witness_approved" />
              <label></label>
            </div>
          </div>
        </div>
      </div>
      <div class="eight wide column pl-0">
        <p class="">Testigo Redes Sociales</p>
        <img
          class="ui fluid image"
          :src="api_host + '/' + selected_bundle.setup.social_witness.relative"
        />
        <div class="ui grid centered m-0">
          <div class="three wide column">Aprobar</div>
          <div class="three wide column has-text-right">
            <div
              class="ui fitted toggle checkbox"
              ref="social_witness_checkbox"
              :data-bundle="selected_bundle.nvb_bundle.bundle_id"
            >
              <input type="checkbox" v-model="d.social_witness_approved" />
              <label></label>
            </div>
          </div>
        </div>
      </div>
      <!-- <pre>{{ selected_bundle }}</pre> -->
    </div>
  </div>
</template>

<script>
import { local_api, error_toast, api_host } from "@/utils";
import moment from "moment";
import { success_toast } from "../../../utils";

export default {
  name: "NvidiaTicketNvidiaSolicitaBundle",
  data() {
    return {
      requests: [],
      selected_bundle: undefined,
      stores: [],
      api_host: api_host,
      d: {
        comment: "",
        web_witness_approved: false,
        social_witness_approved: false,
      },
    };
  },
  computed: {},
  filters: {
    dt(value) {
      let date = moment(value);
      return date.format("DD / MMM / YYYY");
    },
  },
  mounted() {
    let vm = this;
    vm.init();
  },
  methods: {
    init() {
      let vm = this;
      local_api(vm, "post", "/nworkforce/nvidia/do-get-bundle-request-list", {})
        .then(function(r) {
          vm.requests = r;
          // vm.$emit("set_bundles", r.bundles);
        })
        .catch(function(err) {
          error_toast(err);
        });
    },
    setStores(stores) {
      this.stores = stores;
    },
    user_stores(user) {
      let vm = this;
      console.log(user, vm.stores);
      return vm.stores.map((s) => {
        console.log(s);
        return s;
      });
    },
    check(request) {
      let vm = this;
      vm.selected_bundle = request;
      vm.scrollToElement();

      setTimeout(() => {
        window.jQuery(vm.$refs.web_witness_checkbox).checkbox({
          onChange() {
            vm.d.web_witness_approved = window
              .jQuery(vm.$refs.web_witness_checkbox)
              .checkbox("is checked");
          },
        });
        window.jQuery(vm.$refs.social_witness_checkbox).checkbox({
          onChange() {
            vm.d.social_witness_approved = window
              .jQuery(vm.$refs.social_witness_checkbox)
              .checkbox("is checked");
          },
        });
      }, 500);
    },
    scrollToElement() {
      const el = this.$refs.scrollToMe;
      window
        .jQuery(el)
        .animate({ scrollTop: window.jQuery(el).prop("scrollHeight") }, 1000);
    },
    approve() {
      let vm = this;
      // Check if witnesses are approved
      if (vm.d.web_witness_approved && vm.d.social_witness_approved) {
        local_api(vm, "post", "/nworkforce/nvidia/do-approve-bundle-request", {
          data: vm.d,
          u: vm.selected_bundle.request_id,
        })
          .then(function() {
            success_toast(vm.$t("request approved"));
            // Restore to default
            vm.selected_bundle = undefined;
            vm.d = {
              comment: "",
              web_witness_approved: false,
              social_witness_approved: false,
            };
            vm.init();
          })
          .catch(function(err) {
            error_toast(err);
          });
      } else {
        error_toast(
          vm.$t(
            "you must approve both withness to approve this bundle request",
          ),
        );
      }
    },
    deny() {
      let vm = this;
      // Check if some witness is denied
      if (vm.d.comment) {
        local_api(vm, "post", "/nworkforce/nvidia/do-reject-bundle-request", {
          data: vm.d,
          u: vm.selected_bundle.request_id,
        })
          .then(function() {
            success_toast(vm.$t("request rejected"));
            // Restore to default
            vm.selected_bundle = undefined;
            vm.d = {
              comment: "",
              web_witness_approved: false,
              social_witness_approved: false,
            };
            vm.init();
          })
          .catch(function(err) {
            error_toast(err);
          });
      } else {
        error_toast(
          vm.$t(
            "you must provide a comment in order to to reject this bundle request",
          ),
        );
      }
    },
  },
  watch: {},
};
</script>

<style scoped>
/* @import url("https://nworkforce.com/librerias/css/fonts/fonts.css"); */

/*  SPACING   */
.m-0 {
  margin: 0 !important;
}
.my-0 {
  margin-bottom: 0 !important;
  margin-top: 0 !important;
}
.px-gen {
  padding-right: 2rem !important;
  padding-left: 2rem !important;
}
.pb-05 {
  padding-bottom: 0.5rem !important;
}
.pl-0 {
  padding-left: 0 !important;
}
.py-1 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important;
}

/*  FONTS   */
.has-text-centered {
  text-align: center !important;
}
.has-text-left {
  text-align: left !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}
.fdinpro {
  font-family: "DINPro" !important;
}

.default-header-green {
  border-bottom: 2pt solid #365a0c !important;
  font-weight: 300;
  font-size: 1.5rem !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}
.testigos div p {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
  margin-bottom: 0;
}
.testigos div .grid {
  align-items: center !important;
  background-color: #ebebec !important;
}
.sb-tienda {
  display: flex !important;
  flex-direction: row;
  text-align: left !important;
}
.pre-sb-tienda {
  flex: 20%;
}
.name-sb-tienda {
  flex: 80%;
}
</style>
